import React, { useState, useEffect } from 'react';
import moment from 'moment';
import Sidenav from '../Sidenav/Sidenav';
import AddUserModal from './AddUserModal';
import DeleteConfirmationModal from './DeleteUser';
import ApprovalRequestsModal from './ApprovalRequests';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import api from '../api/api';
import correct from '../../src/assets/correct.png';
import wrong from '../../src/assets/wrong.png';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonAddRoundedIcon from '@mui/icons-material/PersonAddRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import Box from '@mui/material/Box';
import { CircularProgress } from "@mui/material";
import { Menu, MenuItem, IconButton } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import Toast from '../global/toastmessage'
import SideNavLayout from '../Sidenav/SideNavLayout';
const MobileIcon = ({ color = "#030213" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
    <path d="M16.4998 2.3335H5.49984C4.48732 2.3335 3.6665 3.15431 3.6665 4.16683V18.8335C3.6665 19.846 4.48732 20.6668 5.49984 20.6668H16.4998C17.5124 20.6668 18.3332 19.846 18.3332 18.8335V4.16683C18.3332 3.15431 17.5124 2.3335 16.4998 2.3335Z" stroke={color} strokeWidth="1.83333" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11 17H11.01" stroke={color} strokeWidth="1.83333" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const Users = () => {
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [devicePopup, setDevicePopup] = useState({ open: false, user: null, anchorEl: null });
  const [appAccessFilter, setAppAccessFilter] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [deviceFilter, setDeviceFilter] = useState('all'); // 'all', 'online', 'offline'
  const [fullNames, setFullNames] = useState("");
  const [isApprovalModalOpen, setIsApprovalModalOpen] = useState(false);
  const [pendingApprovals, setPendingApprovals] = useState(0);
  const loggedInUser = useSelector((state) => state.user.userDetails);
  const isSuperAdmin = loggedInUser?.user_roles?.role === 'Super Admin';
  const navigate = useNavigate();
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success' 
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleMenuOpen = (event, device) => {
    setAnchorEl(event.currentTarget);
    setSelectedUser(device);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const showToast = (message, severity = 'success') => {
    setToast({
      open: true,
      message,
      severity
    });
  };

  const handleCloseToast = () => {
    setToast(prev => ({ ...prev, open: false }));
  };

  const token = sessionStorage.getItem("accessToken");

  
  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await api.get("/v1/users/active");
      if (response.data && Array.isArray(response.data)) {
        // Map the response to ensure we have the correct user_id structure
        const formattedUsers = response.data.map(user => ({
          ...user,
          // Extract user_id based on your API response structure
          id: user.id || user.details?.user_id || user.user_id
        }));
          formattedUsers.sort((a, b) => {
    if (a.status === "I" && b.status !== "I") return 1;   // move a down
    if (a.status !== "I" && b.status === "I") return -1;  // move b down
    return 0; // otherwise keep order
  });
        setUsers(formattedUsers);
      }
    } catch (error) {
      // error handling
    } finally {
      setLoading(false);
    }
  };

  const handleUsernameClick = (user) => {
    setCurrentUser({
      ...user,
      id: user.id || user.details?.user_id || user.user_id
    });
    setIsModalOpen(true);
  };

  const fetchPendingApprovals = async () => {
    if (!isSuperAdmin) return;
    try {
      const response = await api.get('/v1/user-approvals?status=P');
      setPendingApprovals((response.data || []).length);
    } catch (error) {
      console.error('Failed to fetch pending approvals:', error);
    }
  };

    useEffect(() => {
      fetchUsers();
    }, [token]);

    useEffect(() => {
      fetchPendingApprovals();
    }, [token, isSuperAdmin]);

  const toggleMenu = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  const handleEdit = (user) => {
    // Make sure we're passing the correct user_id
    setCurrentUser({
      ...user,
      id: user.id || user.details?.user_id || user.user_id
    });
    setIsModalOpen(true);
  };

  const handleDelete = (user) => {
    // Make sure we're passing the correct user_id
    setCurrentUser({
      ...user,
      id: user.id || user.details?.user_id || user.user_id
    });
    setFullNames(`${user.firstname} ${user.lastname}`);
    setIsDeleteModalOpen(true);
  };

 

  const deleteUser = async () => {
    try {
      const userId = currentUser.id || currentUser.details?.user_id || currentUser.user_id;
      const response = await api.delete(`/v1/users/${userId}`);

      if (response.status === 202) {
        // Non Super Admin: the delete is queued until a Super Admin accepts it
        setIsDeleteModalOpen(false);
        setCurrentUser(null);
        showToast(response.message || 'Delete request sent to Super Admin for approval', 'info');
        return;
      }

      await fetchUsers();
      setUsers(users.filter(user => user.user_id !== currentUser.user_id));
      setIsDeleteModalOpen(false);
      setCurrentUser(null);
      showToast(response.message || 'User deleted successfully');
    } catch (error) {
      console.error('Failed to delete user:', error);
      showToast(error.response?.data?.message || 'Failed to delete user', 'error');
    }
  };



  const handleSaveUser = async (responseData, isEditMode) => {
    await fetchUsers();
    setCurrentUser(null);
    showToast(
      responseData?.message || 
      (isEditMode ? 'User updated successfully' : 'User created successfully')
    );
  };

  

  return (
<SideNavLayout>
      <div className='w-full max-h-[90vh] overflow-y-auto  p-8' style={{scrollbarWidth:'none'}}>
        <div className='flex justify-center gap-2 items-center mb-4'>
          <button onClick={() => navigate('/dashboard')} className='bg-[#145388] flex items-center gap-1 text-white px-3 py-1 rounded-md text-sm font-inter'>
            <HomeRoundedIcon style={{width:"20px"}}/> Home
          </button>
          <button onClick={() => setIsModalOpen(true)} className='bg-[#145388] flex items-center gap-1 text-white px-3 py-1 rounded-md text-sm font-inter'>
            <PersonAddRoundedIcon style={{width:"20px"}}/> Add User
          </button>
          {isSuperAdmin && (
            <button
              onClick={() => setIsApprovalModalOpen(true)}
              className='bg-[#145388] flex items-center gap-1 text-white px-3 py-1 rounded-md text-sm font-inter relative'
            >
              <FactCheckRoundedIcon style={{width:"20px"}}/> Approvals
              {pendingApprovals > 0 && (
                <span className='ml-1 bg-red-600 text-white text-[11px] font-semibold rounded-full px-1.5 py-0.5 leading-none'>
                  {pendingApprovals}
                </span>
              )}
            </button>
          )}
        </div>
        <div className='flex items-center gap-3 mb-4'>
          {/* Search Bar */}
          <div className='flex-1 relative'>
            <input
              type='text'
              placeholder='Search by name, email or phone...'
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className='w-full border border-gray-300 rounded-md px-3 py-1.5 text-sm font-inter focus:outline-none focus:border-[#145388] pl-8'
            />
            <svg className='absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z' />
            </svg>
          </div>

          {/* App Access Filter */}
          <button
            onClick={() => setAppAccessFilter(!appAccessFilter)}
            className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-xs font-inter border transition-colors ${
              appAccessFilter
                ? 'bg-[#145388] text-white border-[#145388]'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            }`}
          >
            <MobileIcon color={appAccessFilter ? '#fff' : '#374151'} />
            App Access
          </button>
        </div>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <div className="text-red-500 text-center p-4">Error loading users: {error}</div>
        ) : (

<div className='bg-white w-[100%] mx-auto  rounded-lg'>
  <div className=' overflow-x-auto scrollbar-thin border  rounded-lg p-4'>
             <table className='w-full table-auto border-collapse '>
  
         <thead className='bg-[#eee] text-left text-gray-700 uppercase text-sm '>
              <tr className='text-xs'>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400 '>Username</th>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400  '>Email</th>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400 '>Phone</th>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400 '>iPad ID</th>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400 text-center'>
                  <button
                    onClick={() => setDeviceFilter(prev => prev === 'all' ? 'online' : prev === 'online' ? 'offline' : 'all')}
                    className='flex items-center gap-1 mx-auto hover:opacity-70 transition-opacity'
                  >
                    Device
                    {deviceFilter === 'online' && <span className='text-green-600 text-[10px]'>▲</span>}
                    {deviceFilter === 'offline' && <span className='text-red-600 text-[10px]'>▼</span>}
                    {deviceFilter === 'all' && <span className='text-gray-400 text-[10px]'>⇅</span>}
                  </button>
                </th>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400 '>Status</th>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400 '>Action</th>
              </tr>
            </thead>
            <tbody className='overflow-y-auto custom-scrollbar max-h-[500px]'>
              {users.filter(user => {
                // Search filter
                if (searchQuery) {
                  const q = searchQuery.toLowerCase();
                  const fullName = `${user.firstname || ''} ${user.lastname || ''}`.toLowerCase();
                  if (!fullName.includes(q) && !(user.email || '').toLowerCase().includes(q) && !(user.phone || '').includes(q)) return false;
                }
                // App Access filter
                if (appAccessFilter && !(user.permissions || user.user_info?.permissions || []).includes('A1')) return false;
                // Device filter
                if (deviceFilter !== 'all') {
                  const hasAppAccess = (user.permissions || user.user_info?.permissions || []).includes('A1');
                  if (!hasAppAccess) return false;
                  const isOnline = user.lastlogin && (!user.lastlogout || moment(user.lastlogin).isAfter(moment(user.lastlogout)));
                  if (deviceFilter === 'online' && !isOnline) return false;
                  if (deviceFilter === 'offline' && isOnline) return false;
                }
                return true;
              }).map((user, index) => (
                <tr key={user.id} className='border-t relative py-3'>
                  <td className='py-2 px-2' align='left'>
                    <button  onClick={() => handleUsernameClick(user)}
                           className='bg-gray-50 border text-[13px] font-inter text-[#374151] px-3 py-1 rounded-md'>
                    {`${user.firstname} ${user.lastname}`}   
                       <KeyboardArrowRightRoundedIcon fontSize="small" />
                    </button>
                  </td>
                  <td  className='py-[11.2px] text-[14px]  px-[12px] text-left font-inter text-[#374151]'>{user.email}</td>
                  <td className='py-2  text-[14px] text-[#374151] pl-4 pr-2 font-inter' align='left'>{user.phone}</td>
                  <td className='py-2 text-[14px] text-[#374151] pl-4 pr-2 font-inter' align='left  '>{user.ipadid || '-'}</td>
                  <td className='py-2 text-[14px] text-[#374151] pl-4 pr-2 font-inter relative' align='center'>
                    {(user.permissions || user.user_info?.permissions || []).includes('A1') ? (
                      <button
                        onClick={(e) => setDevicePopup({ open: true, user, anchorEl: e.currentTarget })}
                        className='p-1 rounded-md hover:bg-gray-100 transition-colors'
                        title={user.lastlogin && (!user.lastlogout || moment(user.lastlogin).isAfter(moment(user.lastlogout))) ? 'Online' : 'Offline'}
                      >
                        <MobileIcon color={user.lastlogin && (!user.lastlogout || moment(user.lastlogin).isAfter(moment(user.lastlogout))) ? '#16a34a' : '#dc2626'} />
                      </button>
                    ) : (
                      <span className='text-gray-300'>-</span>
                    )}
                  </td>
                  <td className='py-2 text-[14px] text-[#374151] pl-4 pr-2 font-inter '  align='left'>
                    {user.status === 'A' ? (
                      <img src={correct} alt="Active" className="h-4 w-4  ml-2" />
                    ) : (
                      <img src={wrong} alt="Inactive" className="h-4 w-4  ml-2" />
                    )}
                  </td>
                  <td className="py-2 px-2" align="left">
      <button
  onClick={(e) => handleMenuOpen(e, user)}
  className="bg-transparent text-[14px] text-[#374151] font-inter px-2 py-1 rounded-md"
      >
        Actions <KeyboardArrowDownRoundedIcon />
      </button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          elevation: 1, // Reduce default elevation
          sx: {
            boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)', // Subtle custom shadow
            borderRadius: '8px'
          }
        }}
      >
        <MenuItem style={{fontSize:"14px"}}
          onClick={() => {
            handleEdit(selectedUser);
            handleMenuClose();
          }}
        >
          <EditIcon style={{color:"gray"}} fontSize="small"  className="mr-2" /> Edit
        </MenuItem>
        <MenuItem style={{fontSize:"14px"}}
          onClick={() => {
            handleDelete(selectedUser);
            handleMenuClose();
          }}
        >
          <DeleteIcon style={{color:"red"}} fontSize="small" className="mr-2" /> Delete
        </MenuItem>
      </Menu>
    </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>

          {/* Device Login/Logout Popup */}
          {devicePopup.open && devicePopup.user && (
            <>
              <div className="fixed inset-0 z-40" onClick={() => setDevicePopup({ open: false, user: null, anchorEl: null })} />
              <div
                className="absolute z-50 bg-white border border-gray-200 rounded-lg shadow-xl p-4 w-72"
                style={{
                  top: devicePopup.anchorEl?.getBoundingClientRect().bottom + window.scrollY + 4,
                  left: devicePopup.anchorEl?.getBoundingClientRect().left + window.scrollX - 100,
                }}
              >
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <MobileIcon color={devicePopup.user.lastlogin && (!devicePopup.user.lastlogout || moment(devicePopup.user.lastlogin).isAfter(moment(devicePopup.user.lastlogout))) ? '#16a34a' : '#dc2626'} />
                    <span className="font-semibold text-sm text-gray-800">
                      {devicePopup.user.lastlogin && (!devicePopup.user.lastlogout || moment(devicePopup.user.lastlogin).isAfter(moment(devicePopup.user.lastlogout))) ? 'Online' : 'Offline'}
                    </span>
                  </div>
                  <button onClick={() => setDevicePopup({ open: false, user: null, anchorEl: null })} className="text-gray-400 hover:text-gray-600">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                  </button>
                </div>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between items-center py-1 border-b border-gray-100">
                    <span className="text-gray-500 font-medium">Last Login</span>
                    <span className="text-gray-800 font-inter">{devicePopup.user.lastlogin ? moment(devicePopup.user.lastlogin).format('MM-DD-YYYY hh:mm:ss A') : '-'}</span>
                  </div>
                  <div className="flex justify-between items-center py-1">
                    <span className="text-gray-500 font-medium">Last Logout</span>
                    <span className="text-gray-800 font-inter">{devicePopup.user.lastlogout ? moment(devicePopup.user.lastlogout).format('MM-DD-YYYY hh:mm:ss A') : '-'}</span>
                  </div>
                </div>
              </div>
            </>
          )}

        </div>

          )}

        <AddUserModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setCurrentUser(null);
        }}
        onSave={handleSaveUser}
        // onSave={fetchUsers}
        editUser={currentUser}
        existingUsers={users}
        showToast={showToast}
      />
        <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          onConfirm={deleteUser}
          deleteConfirm ={fullNames}
          requiresApproval={!isSuperAdmin}
        />
        <ApprovalRequestsModal
          isOpen={isApprovalModalOpen}
          onClose={() => setIsApprovalModalOpen(false)}
          onActionDone={() => {
            fetchUsers();
            fetchPendingApprovals();
          }}
          showToast={showToast}
        />
         <Toast
          open={toast.open}
          onClose={handleCloseToast}
          severity={toast.severity}
          message={toast.message}
        />
      </div>
</SideNavLayout>
  );
};

export default Users;